import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import Turnstile from "react-turnstile";
import configJson from "../config.json";

interface TurnstileWrappedProps {
    action?: string
    onChanged?: (valid: boolean) => void;
}

function TurnstyleWrapped(props: TurnstileWrappedProps) {
    const [recaptchaCompleted, setRecaptchaCompleted] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>();
    const [recaptaKey, setRecaptchaKey] = useState<string>();

    useEffect(() => {
        try {
            const { hostname } = window.location;
            const conf = configJson.find((c) => c.key === hostname);
            if(!conf){
                throw new Error();
            }
            setRecaptchaKey(conf?.siteKey);
        } catch (error) {
            setErrorMessage("Could not configure Turnstyle. Please contact support");
        }
    }, []);

    const handleOnChangedCallback = (boolVal: boolean) => {
        if(typeof props.onChanged === "function") {
            props.onChanged(boolVal);
        }
    };

    const handleFailedRecaptcha = () => {
        setRecaptchaCompleted(false);
        handleOnChangedCallback(false);
        setErrorMessage("Please complete the verification challenge.");
    };

    return (
        <>
            {!recaptchaCompleted && errorMessage ? (
                <Alert severity="error" sx={{ textAlign: "start", padding: 2 }}>
                {errorMessage}
                </Alert>
            ) : undefined}

            <Box marginY={2} display={"flex"} justifyContent={"center"} >
                { recaptaKey && (
                    <Turnstile
                        action={props.action || ""}
                        fixedSize={true}
                        sitekey={recaptaKey || ""}
                        theme="light"
                        onTimeout={handleFailedRecaptcha}
                        onExpire={handleFailedRecaptcha}
                        onVerify={() => {
                            setRecaptchaCompleted(true);
                            handleOnChangedCallback(true);
                        }}
                    />
                )}
            </Box>
        </>
    );
}

export default TurnstyleWrapped;